import chroma, {InterpolationMode} from 'chroma-js';

export const createGradient = (
  colours: string[],
  mode: InterpolationMode = 'rgb',
  grades: number = 8
) => chroma.scale(colours).mode(mode).colors(grades);
